/* MOVTECH — Workshop landing JS.
   Két feladat: a hero visszaszámlálója, és a kosár-fiók megnyitása mobilon.
   Külön fájl, hogy a szekció liquidje olvasható maradjon. */

(function () {
  'use strict';

  /* 2026-10-19: angol oldalon angol felirat */
  var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var isDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var isRo = (document.documentElement.lang || '').toLowerCase().indexOf('ro') === 0;

  /* ---------- visszaszámláló ----------
     A dátum a gyökér `data-datum` attribútumában van (ISO, időzónával). Szerver-oldalon
     nem tudjuk, mennyi van hátra, ezért a blokk `hidden`-nel indul, és csak akkor
     mutatjuk meg, ha van értelmes hátralévő idő. Ha a dátum elmúlt vagy hibás, rejtve marad. */
  function ora() {
    var gyoker = document.querySelector('.mvt-ws');
    var doboz = document.querySelector('[data-ws-ora]');
    if (!gyoker || !doboz) return;

    var cel = new Date(gyoker.getAttribute('data-datum') || '');
    if (isNaN(cel.getTime())) return;

    var napEl = doboz.querySelector('[data-ws-nap]');
    var oraEl = doboz.querySelector('[data-ws-oraszam]');
    var percEl = doboz.querySelector('[data-ws-perc]');
    var mpEl = doboz.querySelector('[data-ws-mp]');

    function frissit() {
      var hatra = cel.getTime() - Date.now();
      if (hatra <= 0) {
        doboz.hidden = true;
        return;
      }
      var osszMp = Math.floor(hatra / 1000);
      var nap = Math.floor(osszMp / 86400);
      var o = Math.floor((osszMp % 86400) / 3600);
      var p = Math.floor((osszMp % 3600) / 60);
      var mp = osszMp % 60;
      if (napEl) napEl.textContent = nap;
      if (oraEl) oraEl.textContent = o;
      if (percEl) percEl.textContent = p;
      if (mpEl) mpEl.textContent = mp;
      doboz.hidden = false;
    }

    frissit();
    /* Másodpercenként lépünk, mert a másodperc is látszik. Ha a doboz kikerülne a
       DOM-ból (téma-szerkesztő újrarajzolás), az időzítő leáll magától. */
    window.setInterval(function () {
      if (!document.body.contains(doboz)) return;
      frissit();
    }, 1000);
  }

  /* ---------- kosár-fiók mobilon ----------
     Asztalon a téma magától nyitja a fiókot, mobilon viszont a bolt beállítása
     `message`, tehát csak egy rövid visszajelzés jönne a fejléc mellett. A landingen
     a fejléc rejtve van, így a látogató semmit sem látna a kosárba tételből.
     Ugyanazt a mozdulatot indítjuk, amit a fejléc kosár-ikonja: így a téma saját
     logikája fut le, nem írunk saját kosár-kezelést. */
  function kosarFiok() {
    document.addEventListener('nextsky:cart:added', function () {
      if (window.innerWidth > 767) return;
      var fiok = document.querySelector('cart-drawer');
      if (!fiok || fiok.classList.contains('active')) return;
      var ikon =
        document.querySelector('#cart-icon-bubble-mobile') ||
        document.querySelector('#cart-icon-bubble');
      if (ikon) ikon.click();
    });
  }

  /* ---------- megtérülés-kalkulátor ----------
     A Shock Wave landing üzleti sávjának mintájára, de a workshop díjára számol:
     hány kezelésből jön vissza a jegy ára, és mennyi bevétel jár a megadott tempóval.
     A díj a Liquidből jön (`data-dij`, forintban), tehát árváltozásnál magától követ. */
  function kalkulator() {
    var doboz = document.querySelector('[data-ws-calc]');
    if (!doboz) return;

    var dij = parseFloat(doboz.getAttribute('data-dij')) || 0;
    var dijMezo = doboz.querySelector('[data-ws-fee]');
    var hetiMezo = doboz.querySelector('[data-ws-weekly]');
    var kezelesKi = doboz.querySelector('[data-ws-kezeles]');
    var bevetelKi = doboz.querySelector('[data-ws-bevetel]');
    if (!dijMezo || !hetiMezo) return;

    function formaz(szam) {
      if (isEn) return Math.round(szam).toLocaleString('en-US') + ' HUF';
      if (isDe) return Math.round(szam).toLocaleString('de-DE') + ' Ft';
      if (isRo) return Math.round(szam).toLocaleString('ro-RO') + ' Ft';
      return Math.round(szam).toLocaleString('hu-HU') + ' Ft';
    }

    function szamol() {
      var egysegAr = Math.max(0, parseFloat(dijMezo.value) || 0);
      var heti = Math.max(0, parseFloat(hetiMezo.value) || 0);

      if (kezelesKi) {
        kezelesKi.textContent = egysegAr > 0 ? Math.ceil(dij / egysegAr) : 0;
      }
      if (bevetelKi) {
        /* Havi bevétel: heti darabszám * 4,33 hét. Nem kerekítjük 4 hétre, mert az
           egy hónapban átlagosan 4,33 hét van, és a 4 érezhetően alábecsülné. */
        bevetelKi.textContent = formaz(egysegAr * heti * 4.33);
      }
    }

    dijMezo.addEventListener('input', szamol);
    hetiMezo.addEventListener('input', szamol);
    szamol();
  }

  /* ---------- mobil ragadós sáv ----------
     Akkor jelenik meg, amikor a hero kigörgött a képernyőről: a heróban ott van a
     jegy-doboz a gombbal, fölösleges lenne kétszer kínálni. A sáv a `hidden`
     attribútummal indul, hogy JS nélkül se villanjon be. */
  function ragadosSav() {
    var sav = document.querySelector('[data-ws-stick]');
    var hero = document.querySelector('.mvt-ws-hero');
    if (!sav || !hero) return;

    if (!('IntersectionObserver' in window)) {
      sav.hidden = false;
      return;
    }

    new IntersectionObserver(function (bejegyzesek) {
      sav.hidden = bejegyzesek[0].isIntersecting;
    }).observe(hero);
  }

  function indul() {
    ora();
    kosarFiok();
    kalkulator();
    ragadosSav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', indul);
  } else {
    indul();
  }
})();
